import { render, staticRenderFns } from "./MainConfirm.vue?vue&type=template&id=312c4dde&scoped=true"
import script from "./MainConfirm.vue?vue&type=script&lang=js"
export * from "./MainConfirm.vue?vue&type=script&lang=js"
import style0 from "./MainConfirm.vue?vue&type=style&index=0&id=312c4dde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312c4dde",
  null
  
)

export default component.exports